import { ChangeEvent, useRef } from "react";
import classNames from "classnames";
import { PlusIcon } from "../../../../shared/icons/PlusIcon";
import { useUploadZone } from "../../hook/use-upload-zone";
import styles from "./styles.module.css";
import { UploadFileButton } from "../../../Components/Buttons/UploadFileButton";

interface Props {
  uploadZoneStyle: "default" | "custom";
  uploadMessage: string;
  handleFileUpload: (e: ChangeEvent<HTMLInputElement>) => void;
  dropHandler: (e: React.DragEvent<HTMLDivElement>) => void;
  info?: string;
  zoneMode?: "upload" | "info";
  className?: string;
}

export const UploadZone = ({
  uploadZoneStyle,
  uploadMessage,
  dropHandler,
  handleFileUpload,
  zoneMode,
  info,
  className,
}: Props) => {
  const { drag, handleDrag, handleDrop, handleLeave } =
    useUploadZone(dropHandler);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const clsZone = classNames(
    styles["upload-zone"],
    drag && styles.dragging,
    uploadZoneStyle === "default" ? styles["upload-zone-default"] : className
  );

  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div
      onDrop={handleDrop}
      onDragEnter={handleDrag}
      onDragOver={handleDrag}
      onDragLeave={handleLeave}
      onClick={handleClick}
      className={clsZone}
    >
      {zoneMode && zoneMode === "info" ? (
        <div className={styles["upload-zone-text"]}>{info}</div>
      ) : (
        <>
          <UploadFileButton
            inputRef={fileInputRef}
            handleFileUpload={handleFileUpload}
            type={"icon_button"}
            icon={<PlusIcon />}
            className={styles["upload-button"]}
          />
          <div className={styles["upload-zone-text"]}>{uploadMessage}</div>
        </>
      )}
    </div>
  );
};
